import { h } from "preact";
import { Card, Typography } from "antd";


export default function PageNotFound(props) {
    return (
        <Card
            bordered={false}
            title={
                <Typography.Title level={4}>
                    404! PAGE NOT FOUND!
                </Typography.Title>
                
            }
        />
    );
}